import { Link } from "react-router-dom";

export function TopNav() {
  return (
    <header
      className="sticky top-0 z-40 border-b border-rule bg-canvas/90 backdrop-blur"
      aria-label="Primary"
    >
      <div className="mx-auto flex h-[72px] max-w-[1440px] items-center justify-between px-6 md:px-[72px]">
        <div className="flex items-center gap-12">
          <Link
            to="/"
            className="flex items-center gap-2 no-underline"
            aria-label="Cloakling — home"
          >
            <img
              src="/logo.png"
              alt=""
              aria-hidden="true"
              className="h-10 w-10 object-contain"
            />
            <span className="text-[18px] font-bold tracking-[-0.2px] text-ink">
              Cloakling
            </span>
          </Link>

          <nav
            className="hidden items-center gap-8 md:flex"
            aria-label="Sections"
          >
            <a
              href="#personal"
              className="text-[14px] font-medium text-ink hover:text-cloak-accent"
            >
              Personal
            </a>
            <a
              href="#small-offices"
              className="text-[14px] font-medium text-graphite hover:text-cloak-accent"
            >
              Small Offices
            </a>
            <a
              href="#how-it-works"
              className="text-[14px] font-medium text-graphite hover:text-cloak-accent"
            >
              How it works
            </a>
          </nav>
        </div>

        <div className="flex items-center gap-2">
          <a
            href="mailto:hello@cloakling.com"
            className="hidden rounded-md px-4 py-2.5 text-[14px] font-semibold text-ink no-underline hover:bg-ink/5 sm:inline-flex"
          >
            Talk to us
          </a>
          <a
            href="https://cloakling.dev"
            className="inline-flex items-center gap-2 rounded-md bg-cloak-accent px-[18px] py-2.5 text-[14px] font-semibold text-page no-underline transition-colors hover:bg-cloak-accent/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cloak-accent focus-visible:ring-offset-2"
          >
            Get access
            <span aria-hidden="true">→</span>
          </a>
        </div>
      </div>
    </header>
  );
}
